








































































import _ from 'lodash'
import BaseInput from '@/services/BaseInput'
import moment from 'moment'
import { Component } from 'vue-property-decorator'

@Component
export default class Date extends BaseInput {

  private menu = false
  private date = this.value || ''
  private activePicker = null

  private localeDate(date, format = 'LL') {
    if (!date) { return ''}
    return typeof date === 'object'
      ? _.map(date, (item) => moment(item).locale('th').add(543, 'year').format(format))
      : moment(date).locale('th').add(543, 'year').format(format)
  }

  private changeDateType() {
    this.menu = false
  }

  private doDeleteItem(item) {
    this.innerValue = typeof this.value === 'object'
      ? _.filter(this.value, (val) => item !== val)
      : null
  }
}
